import { getReCaptchaToken } from './get_recaptcha_token';
import initAddressAutocomplete from './address_autocomplete';
import initFieldCounter  from "./field_counter.ts";

export default function initAjaxForm(el: string, url: string) {
    const form = document.getElementById(el) as HTMLFormElement;
    if (!form || form.classList.contains('ajax-form')) {
        return;
    }

    const postLoad = () => {
        // Handle address autocomplete
        initAddressAutocomplete(form, '#reaction_profile_postcode', '#reaction_profile_number', '#reaction_profile_street', '#reaction_profile_town');

        // Handle character counter on textarea fields
        initFieldCounter(form);
    }

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        let submitButton = form.querySelector('[type="submit"]') as HTMLButtonElement;
        if (submitButton) {
            if (submitButton.disabled) {
                return;
            }
            submitButton.disabled = true;
            submitButton.classList.add('icon-spinner');
        }

        const token = await getReCaptchaToken('send_' + el.replace(/-/g, '_'));

        const formData = new FormData(e.target as HTMLFormElement);
        formData.append('g-recaptcha-response', token);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        if (!res.ok) {
            // TODO show Toast message?
            return;
        }
        const data = await res.json();
        if (data.success) {
            if (data.hasOwnProperty('redirect')) {
                window.location.href = data.redirect;
            }
        } else {
            if (data.hasOwnProperty('body')) {
                form.innerHTML = data.body;
                postLoad();
            }
            if (data.hasOwnProperty('message')) {
                // TODO show Toast message?
                const notice = form.querySelector('.notice-error') as HTMLElement;
                if (notice) {
                    notice.innerHTML = data.message;
                    notice.classList.remove('hidden');
                }
            }
        }

        submitButton.disabled = false;
        submitButton.classList.remove('icon-spinner');
    });

    postLoad();

    form.classList.add('ajax-form');
}